import React from 'react';
import image1 from './img/team3.jpeg';
import image2 from './img/team2.jpeg';
import image3 from './img/john supakin.jpg'; // NEW IMAGE

const OurTeam = () => {
  return (
    <div className="team-container mt-5">
      <div className="team-header">
        <h1 className="team-title">
          Meet Our <span>Expert Team</span>
        </h1>
        <p className="team-intro">
          A dedicated group of cybersecurity professionals committed to protecting your digital assets
        </p>
      </div>

      <div className="leadership-section">
        <h2 className="section-title">Leadership</h2>

        <div className="leadership-grid">
          {/* Leader 1 */}
          <div className="leader-card">
            <div className="leader-image-wrapper">
              <img src={image1} alt="Mr. Vinay Rana" className="leader-image vinay-image" />
              <div className="leader-overlay"></div>
            </div>
            <div className="leader-details">
              <h3 className='leader-name'>Mr. Vinay Rana</h3>
              <p className="leader-bio">
                He is an experienced IT professional with 30+ years of experience in the IT industry.
                He specializes in Cyber Security. He has worked with global customers from various
                industry verticals to understand their business challenges and develop end-to-end
                cybersecurity strategies to address their needs.
              </p>
            </div>
          </div>

          {/* Leader 2 */}
          <div className="leader-card">
            <div className="leader-image-wrapper">
              <img src={image2} alt="Mr. Subash Babu PK" className="leader-image" />
              <div className="leader-overlay"></div>
            </div>
            <div className="leader-details">
              <h3 className='leader-name'>Mr. Subash Babu PK</h3>
              <p className="leader-bio">
                Experienced cybersecurity leader serving as the Kerala State Head for the National
                Cyber Defence Research Centre. With a specialized focus in cybersecurity, he is
                dedicated to advancing national cyber defense initiatives and building secure digital
                infrastructures. Known for expertise in cyber threat management, digital forensics,
                and security awareness.
              </p>
            </div>
          </div>

          {/* Leader 3 - NEW */}
          <div className="leader-card">
            <div className="leader-image-wrapper">
              <img src={image3} alt="Mr. John Supakin" className="leader-image" />
              <div className="leader-overlay"></div>
            </div>
            <div className="leader-details">
              <h3 className='leader-name'>Mr. John Supakin</h3>
              <p className="leader-bio">
                A visionary CTO with over 25+ years of leadership in product management, enterprise
                innovation, and technical architecture. He has led AI-driven transformations across
                healthcare, recruitment, and operations while strengthening cybersecurity frameworks
                to protect systems and data. He delivers resilient solutions that align technology
                with business goals and empower teams to excel.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurTeam;
